import { createAction, createReducer, createSelector } from '@reduxjs/toolkit'
import queryString from 'query-string'
import { selectProperties } from './properties'
import parseIncomingParams from '../utilities/parseIncomingParams'
import { selectPromos } from './promos'

const handleFetch = createAction('config/fetch')
export const handleReceive = createAction('config/receive')
export const handleError = createAction('config/error')
export const handleReceiveNotifications = createAction(
  'config/receive-notifications'
)
const initialState = {
  loading: true,
  data: null,
  error: null,
}

export const configReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(handleFetch, (state) => {
      state.loading = true
    })
    .addCase(handleReceive, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    .addCase(handleError, (state, action) => {
      state.loading = false
      state.error = action.payload
    })
    .addCase(handleReceiveNotifications, (state, action) => {
      state.notifications = action.payload
    })
})

const selectStateConfig = (state) => state.configuration

export const selectConfigState = createSelector(
  selectStateConfig,
  (configuration) => configuration
)

export const selectConfigData = createSelector(
  selectStateConfig,
  (config) => config?.data || {}
)

export const selectLabels = createSelector(
  selectConfigData,
  (data) => data?.hotel?.labels || {}
)
const selectConfigNotifications = createSelector(
  selectConfigState,
  (config) => config?.notifications || []
)
export const selectBrandAlerts = createSelector(
  [selectConfigNotifications, (state, id = 'arr') => id],
  (notifications, id) => {
    return notifications.reduce((arr, notification) => {
      if (notification.id === id && notification.alerts?.length) {
        notification.alerts.forEach((alert, i) => {
          const { displayStart, displayEnd, searchStart, searchEnd } = alert
          const now = Math.round(new Date().getTime() / 1000)

          const isWithinSearchRange = now > searchStart && now < searchEnd
          const isWithinDisplayWindow = now > displayStart && now < displayEnd

          if (isWithinSearchRange && isWithinDisplayWindow) {
            arr.push({
              ...alert,
              uniqueId: `${alert.propertyId}-${searchStart}-${searchEnd}-${i}`,
            })
          }
        })
      }

      return arr
    }, [])
  }
)

export const selectDefaultSearchParams = createSelector(
  [selectProperties, selectPromos],
  (properties, promos) =>
    parseIncomingParams({
      params: queryString.parse(window.location.search),
      properties,
      promos,
    })
)
